"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = void 0;
exports.json = {
    programs: [
        {
            id: 1,
            value: "Automotive Technician",
            name: "Automotive Technician"
        },
        {
            id: 2,
            value: "Computer Systems Technician",
            name: "Computer Systems Technician"
        },
        {
            id: 3,
            value: "Cosmetologist",
            name: "Cosmetologist"
        },
        {
            id: 4,
            value: "Dental Assistant",
            name: "Dental Assistant"
        },
        {
            id: 5,
            value: "Massage Therapy",
            name: "Massage Therapy"
        },
        {
            id: 6,
            value: "Medical Assistant",
            name: "Medical Assistant"
        },
        {
            id: 7,
            value: "Refrigeration & HVAC",
            name: "Refrigeration & HVAC"
        },
        {
            id: 8,
            value: "Nursing Assistant",
            name: "Nursing Assistant"
        },
        {
            id: 9,
            value: "Medical Billing and Coding",
            name: "Medical Billing and Coding"
        },
        {
            id: 10,
            value: "AUTOMOTIVE",
            name: "AUTOMOTIVE"
        },
        {
            id: 11,
            value: "Biomedical Equipment Technician",
            name: "Biomedical Equipment Technician"
        },
        {
            id: 12,
            value: "Business Office Admin",
            name: "Business Office Admin"
        },
        {
            id: 13,
            value: "Business Office Administration",
            name: "Business Office Administration"
        },
        {
            id: 14,
            value: "Computer Network Systems",
            name: "Computer Network Systems"
        },
        {
            id: 15,
            value: "General",
            name: "General"
        },
        {
            id: 16,
            value: "HVAC/R",
            name: "HVAC/R"
        },
        {
            id: 18,
            value: "Personal Trainer",
            name: "Personal Trainer"
        },
        {
            id: 19,
            value: "Pharmacy Technician",
            name: "Pharmacy Technician"
        },
        {
            id: 20,
            value: "Refrigeration and HVAC Technician",
            name: "Refrigeration and HVAC Technician"
        },
        {
            id: 21,
            value: "Cosmetology",
            name: "Cosmetology"
        },
        {
            id: 22,
            value: "Not Sure",
            name: "Not Sure"
        },
        {
            id: 23,
            value: "Undecided",
            name: "Undecided"
        },
        {
            id: 24,
            value: "Medical Billing and Coding Program",
            name: "Medical Billing and Coding Program"
        },
        {
            id: 25,
            value: "Electrical Technician",
            name: "Electrical Technician"
        },
        {
            id: 26,
            value: "Other",
            name: "Other"
        }
    ],
    states: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "District of Columbia", abbreviation: "DC" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Lousiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ],
    tabs: [
        {
            step: "1",
            title: "Application"
        },
        {
            step: "2",
            title: "Education Disclosure"
        },
        {
            step: "3",
            title: "Code of Computing"
        },
        {
            step: "4",
            title: "Felony Acknowledgement Form"
        },
        {
            step: "5",
            title: "Identity Authentication Form"
        },
        {
            step: "6",
            title: "Online Education Disclosure"
        },
        {
            step: "7",
            title: "CPA Eligibility Form"
        },
        {
            step: "8",
            title: "Technical Standards Form"
        },
        {
            step: "9",
            title: "HIM Technical Standards"
        },
        {
            step: "10",
            title: "Transferability of Credits Form"
        },
        {
            step: "11",
            title: "Disclosure of Info Mississippi"
        },
        {
            step: "12",
            title: "Finish & Submit"
        }
    ],
    campuses: [
        {
            id: 1,
            name: "Colorado Springs",
            value: "Colorado Springs"
        },
        {
            id: 2,
            name: "Albuquerque",
            value: "Albuquerque"
        },
        {
            id: 3,
            name: "Grand Junction",
            value: "Grand Junction"
        },
        {
            id: 4,
            name: "Pueblo",
            value: "Pueblo"
        }
    ],
    totalCredits: [
        {
            name: "4",
            value: "4"
        },
        {
            name: "6",
            value: "6"
        },
        {
            name: "8",
            value: "8"
        },
        {
            name: "10",
            value: "10"
        },
        {
            name: "12",
            value: "12"
        },
        {
            name: "16",
            value: "16"
        },
        {
            name: "20",
            value: "20"
        },
        {
            name: "24",
            value: "24"
        },
        {
            name: "28",
            value: "28"
        },
        {
            name: "32",
            value: "32"
        },
        {
            name: "36",
            value: "36"
        },
        {
            name: "40",
            value: "40"
        },
        {
            name: "44",
            value: "44"
        },
        {
            name: "48",
            value: "48"
        },
        {
            name: "49",
            value: "49"
        },
        {
            name: "52",
            value: "52"
        },
        {
            name: "56",
            value: "56"
        },
        {
            name: "60",
            value: "60"
        },
        {
            name: "64",
            value: "64"
        },
        {
            name: "72",
            value: "72"
        },
        {
            name: "84",
            value: "84"
        },
        {
            name: "92",
            value: "92"
        },
        {
            name: "96",
            value: "96"
        },
        {
            name: "133",
            value: "133"
        },
        {
            name: "180",
            value: "180"
        }
    ],
    hhs: {
        campuses: [
            {
                id: 1,
                name: "Escondido",
                code: "C0",
                address: "125 W Mission Ave #212 Escondido, CA 92025",
                state: "Escondido, CA 92025",
                phone: "(760) 746-9364 ext 1",
                school_code: "3700511",
                region: {
                    id: 1,
                    state: "California",
                    region: "San Diego"
                },
                programs: [
                    {
                        id: 1,
                        name: "Holistic Health Practitioner Program",
                        code: "HHPP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "51%",
                                            graduates: "$8833",
                                            passed: "51%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "42%",
                                            graduates: "$8174",
                                            passed: "56%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "4",
                                            graduate2: "2",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "8",
                                            graduate2: "4",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "11",
                                            completion: "10%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "34",
                                            completion: "33%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "40",
                                            completion: "36%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "42",
                                            completion: "41%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "33",
                                            row1: "0",
                                            row2: "2",
                                            row3: "4",
                                            row4: "2",
                                            row5: "5",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "30",
                                            row1: "0",
                                            row2: "0",
                                            row3: "0",
                                            row4: "0",
                                            row5: "1",
                                            row6: "0"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "2",
                                            row8: "2",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "0",
                                            row13: "0",
                                            row14: " ",
                                            row15: "14"
                                        },
                                        {
                                            row7: "1",
                                            row8: "2",
                                            row9: "1",
                                            row10: "0",
                                            row11: "1",
                                            row12: "2",
                                            row13: "2",
                                            row14: " ",
                                            row15: "20"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$95,001 to $100,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            graduates: "43",
                                            employment: "43",
                                            employed: "33",
                                            rate: "77%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            graduates: "45",
                                            employment: "45",
                                            employed: "30",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "20",
                                            graduate: "33"
                                        },
                                        {
                                            year: 2021,
                                            total: "13",
                                            graduate: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "33",
                                            graduate2: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "30",
                                            graduate2: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$14,000",
                            charge_last_year_two: "$13,000"
                        }
                    },
                    {
                        id: 2,
                        name: "Massage Therapist Program",
                        code: "MTP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "28%",
                                            graduates: "$5767",
                                            passed: "40%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "25%",
                                            graduates: "$5021",
                                            passed: "32%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "10",
                                            graduate2: "3",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "9",
                                            graduate2: "18",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "66",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "62",
                                            completion: "50%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "72",
                                            completion: "65%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "65",
                                            completion: "52%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "75",
                                            completion: "68%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "61",
                                            graduates2: "37",
                                            row1: "0",
                                            row2: "2",
                                            row3: "1",
                                            row4: "2",
                                            row5: "1",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "54",
                                            row1: "1",
                                            row2: "1",
                                            row3: "1",
                                            row4: "0",
                                            row5: "1",
                                            row6: "1"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "0",
                                            row15: "1"
                                        },
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "2",
                                            row10: "0",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "1",
                                            row15: "2"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$40,001 to $45,000"]
                                        },
                                        {
                                            title: ["$45,001 to $50,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$55,001 to $60,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$65,001 to $70,000"]
                                        },
                                        {
                                            title: ["$70,001 to $75,000"]
                                        }
                                    ]
                                },
                                salary_wage_2: {
                                    tableBody: [
                                        {
                                            row16: "0",
                                            row17: "0",
                                            row18: "0",
                                            row19: "0",
                                            row20: "1",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "22"
                                        },
                                        {
                                            row16: "1",
                                            row17: "2",
                                            row18: "1",
                                            row19: "2",
                                            row20: "4",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "28"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$80,001 to $85,000"]
                                        },
                                        {
                                            title: ["$85,001 to $90,000"]
                                        },
                                        {
                                            title: ["$90,001 to $95,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            graduates: "66",
                                            employment: "37",
                                            employed: "61",
                                            rate: "61%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            graduates: "77",
                                            employment: "54",
                                            employed: "77",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "22",
                                            graduate: "37"
                                        },
                                        {
                                            year: 2021,
                                            total: "21",
                                            graduate: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "37",
                                            graduate2: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "54",
                                            graduate2: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$7,800",
                            charge_last_year_two: "$8,400"
                        }
                    }
                ]
            },
            {
                id: 2,
                name: "Kearny Mesa",
                code: "C1",
                address: "9025 Balboa Ave #130 San Diego, CA 92123",
                state: "San Diego, CA 92123",
                phone: "(858) 505-1100 ext 3",
                school_code: "3700511",
                region: {
                    id: 1,
                    state: "California",
                    region: "San Diego"
                },
                programs: [
                    {
                        id: 1,
                        name: "Holistic Health Practitioner Program",
                        code: "HHPP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "51%",
                                            graduates: "$8833",
                                            passed: "51%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "42%",
                                            graduates: "$8174",
                                            passed: "56%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "4",
                                            graduate2: "2",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "8",
                                            graduate2: "4",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "11",
                                            completion: "10%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "34",
                                            completion: "33%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "40",
                                            completion: "36%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "42",
                                            completion: "41%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "33",
                                            row1: "0",
                                            row2: "2",
                                            row3: "4",
                                            row4: "2",
                                            row5: "5",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "30",
                                            row1: "0",
                                            row2: "0",
                                            row3: "0",
                                            row4: "0",
                                            row5: "1",
                                            row6: "0"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "2",
                                            row8: "2",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "0",
                                            row13: "0",
                                            row14: " ",
                                            row15: "14"
                                        },
                                        {
                                            row7: "1",
                                            row8: "2",
                                            row9: "1",
                                            row10: "0",
                                            row11: "1",
                                            row12: "2",
                                            row13: "2",
                                            row14: " ",
                                            row15: "20"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$95,001 to $100,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            graduates: "43",
                                            employment: "43",
                                            employed: "33",
                                            rate: "77%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            graduates: "45",
                                            employment: "45",
                                            employed: "30",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "20",
                                            graduate: "33"
                                        },
                                        {
                                            year: 2021,
                                            total: "13",
                                            graduate: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "33",
                                            graduate2: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "30",
                                            graduate2: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$14,000",
                            charge_last_year_two: "$13,000"
                        }
                    },
                    {
                        id: 2,
                        name: "Massage Therapist Program",
                        code: "MTP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "28%",
                                            graduates: "$5767",
                                            passed: "40%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "25%",
                                            graduates: "$5021",
                                            passed: "32%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "10",
                                            graduate2: "3",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "9",
                                            graduate2: "18",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "66",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "62",
                                            completion: "50%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "72",
                                            completion: "65%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "65",
                                            completion: "52%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "75",
                                            completion: "68%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "61",
                                            graduates2: "37",
                                            row1: "0",
                                            row2: "2",
                                            row3: "1",
                                            row4: "2",
                                            row5: "1",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "54",
                                            row1: "1",
                                            row2: "1",
                                            row3: "1",
                                            row4: "0",
                                            row5: "1",
                                            row6: "1"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "0",
                                            row15: "1"
                                        },
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "2",
                                            row10: "0",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "1",
                                            row15: "2"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$40,001 to $45,000"]
                                        },
                                        {
                                            title: ["$45,001 to $50,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$55,001 to $60,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$65,001 to $70,000"]
                                        },
                                        {
                                            title: ["$70,001 to $75,000"]
                                        }
                                    ]
                                },
                                salary_wage_2: {
                                    tableBody: [
                                        {
                                            row16: "0",
                                            row17: "0",
                                            row18: "0",
                                            row19: "0",
                                            row20: "1",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "22"
                                        },
                                        {
                                            row16: "1",
                                            row17: "2",
                                            row18: "1",
                                            row19: "2",
                                            row20: "4",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "28"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$80,001 to $85,000"]
                                        },
                                        {
                                            title: ["$85,001 to $90,000"]
                                        },
                                        {
                                            title: ["$90,001 to $95,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            graduates: "66",
                                            employment: "37",
                                            employed: "61",
                                            rate: "61%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            graduates: "77",
                                            employment: "54",
                                            employed: "77",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "22",
                                            graduate: "37"
                                        },
                                        {
                                            year: 2021,
                                            total: "21",
                                            graduate: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "37",
                                            graduate2: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "54",
                                            graduate2: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$7,800",
                            charge_last_year_two: "$8,400"
                        }
                    }
                ]
            },
            {
                id: 3,
                name: "Laguna Hills",
                code: "C2",
                address: "23022 La Cadena Dr., #205 Laguna Hills, CA 92653",
                state: "Laguna Hills, CA 92653",
                phone: "(949) 305-2722 ext 2",
                school_code: "3700511",
                region: {
                    id: 1,
                    state: "California",
                    region: "San Diego"
                },
                programs: [
                    {
                        id: 1,
                        name: "Holistic Health Practitioner Program",
                        code: "HHPP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "51%",
                                            graduates: "$8833",
                                            passed: "51%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "42%",
                                            graduates: "$8174",
                                            passed: "56%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "4",
                                            graduate2: "2",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "8",
                                            graduate2: "4",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "11",
                                            completion: "10%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "34",
                                            completion: "33%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            students: "111",
                                            graduates: "40",
                                            completion: "36%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            students: "103",
                                            graduates: "42",
                                            completion: "41%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "43",
                                            graduates2: "33",
                                            row1: "0",
                                            row2: "2",
                                            row3: "4",
                                            row4: "2",
                                            row5: "5",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "45",
                                            graduates2: "30",
                                            row1: "0",
                                            row2: "0",
                                            row3: "0",
                                            row4: "0",
                                            row5: "1",
                                            row6: "0"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "2",
                                            row8: "2",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "0",
                                            row13: "0",
                                            row14: " ",
                                            row15: "14"
                                        },
                                        {
                                            row7: "1",
                                            row8: "2",
                                            row9: "1",
                                            row10: "0",
                                            row11: "1",
                                            row12: "2",
                                            row13: "2",
                                            row14: " ",
                                            row15: "20"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$95,001 to $100,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "111",
                                            graduates: "43",
                                            employment: "43",
                                            employed: "33",
                                            rate: "77%"
                                        },
                                        {
                                            year: 2021,
                                            program: "103",
                                            graduates: "45",
                                            employment: "45",
                                            employed: "30",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "20",
                                            graduate: "33"
                                        },
                                        {
                                            year: 2021,
                                            total: "13",
                                            graduate: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "33",
                                            graduate2: "0",
                                            total: "33"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "30",
                                            graduate2: "0",
                                            total: "30"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$14,000",
                            charge_last_year_two: "$13,000"
                        }
                    },
                    {
                        id: 2,
                        name: "Massage Therapist Program",
                        code: "MTP",
                        spfInfo: {
                            id: 1,
                            spf: {
                                loan: {
                                    tableBody: [
                                        {
                                            year: "2020",
                                            default: "11.2",
                                            recieved: "28%",
                                            graduates: "$5767",
                                            passed: "40%"
                                        },
                                        {
                                            year: "2021",
                                            default: "1.4",
                                            recieved: "25%",
                                            graduates: "$5021",
                                            passed: "32%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Most recent three year cohort default rate, as reported by the United State Department of Education.",
                                                "1"
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of enrolled students in",
                                                "",
                                                "receiving federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The percentage of graduates in",
                                                "",
                                                "who took out federal student loans to pay for this program."
                                            ]
                                        },
                                        {
                                            title: [
                                                "The average amount of federal student loan debt of",
                                                "",
                                                "graduates who took out federal student loans at this institution."
                                            ]
                                        }
                                    ]
                                },
                                part_time: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "10",
                                            graduate2: "3",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "9",
                                            graduate2: "18",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field 20-29 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field at Least 30 Hours Per Week"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                examination: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "66",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "0",
                                            passed: "0",
                                            failed: "0",
                                            rate: "0%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates in Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Graduates Taking Exam"]
                                        },
                                        {
                                            title: ["Number Who Passed First Available Exam Exam"]
                                        },
                                        {
                                            title: ["Number Who Failed First Available Exam"]
                                        },
                                        {
                                            title: ["Passage Rate"]
                                        }
                                    ]
                                },
                                performance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "62",
                                            completion: "50%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "72",
                                            completion: "65%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["Number of On- Time Graduates"]
                                        },
                                        {
                                            title: ["On-Time Completion Rate"]
                                        }
                                    ]
                                },
                                published_program: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            students: "125",
                                            graduates: "65",
                                            completion: "52%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            students: "111",
                                            graduates: "75",
                                            completion: "68%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Students Available for Graduation"]
                                        },
                                        {
                                            title: ["150% Graduates"]
                                        },
                                        {
                                            title: ["150 % Completion Rate"]
                                        }
                                    ]
                                },
                                salary_wage: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduates1: "61",
                                            graduates2: "37",
                                            row1: "0",
                                            row2: "2",
                                            row3: "1",
                                            row4: "2",
                                            row5: "1",
                                            row6: "0"
                                        },
                                        {
                                            year: 2021,
                                            graduates1: "77",
                                            graduates2: "54",
                                            row1: "1",
                                            row2: "1",
                                            row3: "1",
                                            row4: "0",
                                            row5: "1",
                                            row6: "1"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in Field"]
                                        },
                                        {
                                            title: ["$0 to $5,000"]
                                        },
                                        {
                                            title: ["$5,001 to $10,000"]
                                        },
                                        {
                                            title: ["$10,001 to $15,000"]
                                        },
                                        {
                                            title: ["$15,001 to $20,000"]
                                        },
                                        {
                                            title: ["$20,001 to $25,000"]
                                        },
                                        {
                                            title: ["$25,001 to $30,000"]
                                        }
                                    ]
                                },
                                salary_wage_1: {
                                    tableBody: [
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "0",
                                            row10: "1",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "0",
                                            row15: "1"
                                        },
                                        {
                                            row7: "1",
                                            row8: "1",
                                            row9: "2",
                                            row10: "0",
                                            row11: "1",
                                            row12: "1",
                                            row13: "2",
                                            row14: "1",
                                            row15: "2"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$30,001 to $35,000"]
                                        },
                                        {
                                            title: ["$35,001 to $40,000"]
                                        },
                                        {
                                            title: ["$40,001 to $45,000"]
                                        },
                                        {
                                            title: ["$45,001 to $50,000"]
                                        },
                                        {
                                            title: ["$50,001 to $55,000"]
                                        },
                                        {
                                            title: ["$55,001 to $60,000"]
                                        },
                                        {
                                            title: ["$60,001 to $65,000"]
                                        },
                                        {
                                            title: ["$65,001 to $70,000"]
                                        },
                                        {
                                            title: ["$70,001 to $75,000"]
                                        }
                                    ]
                                },
                                salary_wage_2: {
                                    tableBody: [
                                        {
                                            row16: "0",
                                            row17: "0",
                                            row18: "0",
                                            row19: "0",
                                            row20: "1",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "22"
                                        },
                                        {
                                            row16: "1",
                                            row17: "2",
                                            row18: "1",
                                            row19: "2",
                                            row20: "4",
                                            row21: " ",
                                            row22: " ",
                                            row23: " ",
                                            noSalary: "28"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["$75,001 to $80,000"]
                                        },
                                        {
                                            title: ["$80,001 to $85,000"]
                                        },
                                        {
                                            title: ["$85,001 to $90,000"]
                                        },
                                        {
                                            title: ["$90,001 to $95,000"]
                                        },
                                        {
                                            title: ["Over $100,000"]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: [""]
                                        },
                                        {
                                            title: ["No Salary Information Reported"]
                                        }
                                    ]
                                },
                                institutional: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field who are Employed by the Institution, an Employer Owned by the Institution, or an Employer who Shares Ownership with the Institution."
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                job_placement: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            program: "125",
                                            graduates: "66",
                                            employment: "37",
                                            employed: "61",
                                            rate: "61%"
                                        },
                                        {
                                            year: 2021,
                                            program: "111",
                                            graduates: "77",
                                            employment: "54",
                                            employed: "77",
                                            rate: "67%"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: ["Number of Students Who Began the Program"]
                                        },
                                        {
                                            title: ["Number of Graduates"]
                                        },
                                        {
                                            title: ["Graduates Available for Employment"]
                                        },
                                        {
                                            title: ["Graduates Employed in the Field"]
                                        },
                                        {
                                            title: ["Placement Rate % Employed in the Field"]
                                        }
                                    ]
                                },
                                self_freelance: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            total: "22",
                                            graduate: "37"
                                        },
                                        {
                                            year: 2021,
                                            total: "21",
                                            graduate: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed who are Self-Employed or Working Freelance"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                },
                                position_aggregated: {
                                    tableBody: [
                                        {
                                            year: 2020,
                                            graduate1: "37",
                                            graduate2: "0",
                                            total: "37"
                                        },
                                        {
                                            year: 2021,
                                            graduate1: "54",
                                            graduate2: "0",
                                            total: "54"
                                        }
                                    ],
                                    tableHeader: [
                                        {
                                            title: ["Calendar Year"]
                                        },
                                        {
                                            title: [
                                                "Graduate Employed in the Field in a Single Position"
                                            ]
                                        },
                                        {
                                            title: [
                                                "Graduates Employed in the Field in Concurrent Aggregated Positions"
                                            ]
                                        },
                                        {
                                            title: ["Total Graduates Employed in the Field"]
                                        }
                                    ]
                                }
                            },
                            charge_last_year: "$7,800",
                            charge_last_year_two: "$8,400"
                        }
                    }
                ]
            }
        ]
    },
    default: {
        id: 0,
        region_id: 0,
        name: "Default",
        code: "Default",
        address: "Default",
        state: "Default",
        phone: "000-000-0000",
        school_code: "0000000",
        region: {
            id: 0,
            state: "Default",
            region: "Default"
        },
        programs: [
            {
                id: 0,
                name: "Default",
                code: "Default",
                charge: "0",
                quant_hours: "0",
                spfInfo: {
                    id: 1,
                    spf: {
                        loan: {
                            tableBody: [],
                            tableHeader: []
                        },
                        part_time: {
                            tableBody: [],
                            tableHeader: []
                        },
                        examination: {
                            tableBody: [],
                            tableHeader: []
                        },
                        performance: {
                            tableBody: [],
                            tableHeader: []
                        },
                        salary_wage: {
                            tableBody: [],
                            tableHeader: []
                        },
                        institutional: {
                            tableBody: [],
                            tableHeader: []
                        },
                        job_placement: {
                            tableBody: [],
                            tableHeader: []
                        },
                        self_freelance: {
                            tableBody: [],
                            tableHeader: []
                        },
                        position_aggregated: {
                            tableBody: [],
                            tableHeader: []
                        },
                        published_program: {
                            tableBody: [],
                            tableHeader: []
                        },
                        salary_wage_1: {
                            tableBody: [],
                            tableHeader: []
                        },
                        salary_wage_2: {
                            tableBody: [],
                            tableHeader: []
                        }
                    },
                    charge_last_year: "$0,000",
                    charge_last_year_two: "$0,000"
                }
            }
        ]
    }
};
//# sourceMappingURL=data:application/json;base64,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